import { ResponseModel } from "../models/ResponseModel";
import { AjaxService } from "../shared/services/AjaxService";

export type DietDto = {
    dietId?: string | null;
    userId?: string | null;
    date: string; // yyyy-MM-dd
    morning?: string | null;
    afternoon?: string | null;
    night?: string | null;
};

export type DietFilterDto = {
    userId?: string | null;
    fromDate: string; // yyyy-MM-dd
    toDate: string;   // yyyy-MM-dd
};

// NOTE: Your backend sample for getDietHistory does NOT include DietId.
// But edit/delete requires dietId. So I kept it optional.
// Best: add DietId in getDietHistory select.
export type DietHistoryItem = {
    date: string; // can be dd-MM-yyyy OR yyyy-MM-dd depending on backend
    data: {
        morning?: string | null;
        afternoon?: string | null;
        night?: string | null;
        dietId?: string | null;
        isEditable: boolean;
    };
};

export type GetDietAgainstDateDto = {
    date: string;
};

export const DietService = {
    async create(payload: DietDto): Promise<ResponseModel> {
        return AjaxService.post<ResponseModel>("/Diet/create", payload);
    },

    async update(payload: DietDto): Promise<ResponseModel> {
        return AjaxService.put<ResponseModel>("/Diet/update", payload);
    },

    async delete(dietId: string): Promise<ResponseModel> {
        return AjaxService.delete<ResponseModel>(
            `/Diet/delete?dietId=${encodeURIComponent(dietId)}`
        );
    },

    async getDietHistory(payload: DietFilterDto): Promise<ResponseModel> {
        return AjaxService.post<ResponseModel>("/Diet/getDietHistory", payload);
    },

    async getDiet(dietId: string): Promise<ResponseModel> {
        return AjaxService.get<ResponseModel>(
            `/Diet/getDiet?dietId=${encodeURIComponent(dietId)}`
        );
    },

    async getDietAgainstDate(payload: GetDietAgainstDateDto): Promise<ResponseModel> {
        return AjaxService.post("/Diet/getDietAgainstDate", payload);
    }
};
